import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "material-symbols-outlined text-[#AFAFAF] !text-5xl md:!text-6xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["flex flex-col items-center justify-center gap-1 md:gap-3 py-8 px-2 rounded-xl border border-[#707070] aspect-[120/132] md:aspect-[198/172] w-full max-w-[120px] md:max-w-[198px] h-full text-[#7E7E7E] txt__notoSB16 hover:bg-gray-50", { 'bg-[#F97066]/10 border-[#F97066] text-[#F97066]': $props.active }]),
    type: "button",
    disabled: $props.disabled,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.emit('clickReaction', $setup.props.type)), ["prevent"]))
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString($props.icon), 1 /* TEXT */),
    _createElementVNode("div", null, [
      _createElementVNode("p", null, _toDisplayString($props.label), 1 /* TEXT */),
      _createElementVNode("p", null, "(" + _toDisplayString($props.count ?? 0) + ")", 1 /* TEXT */)
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}